import styled, {css} from 'styled-components'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'

export const StyledExportsList = styled(Flexbox)(
    () => css`
        width: 100%;
    `
)

export const StyledExportsEmptyState = styled(Flexbox)(
    ({theme: {spacing}}) => css`
        height: 100%;
        padding: ${spacing * 8}px ${spacing * 4}px;
        text-align: center;
    `
)
